// DS: MO3.4.3
import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationShopCard from '../DeviationShopCard';
import { Props as DeviationShopCardProps } from '../DeviationShopCard/DeviationShopCard';
import AdoptableCardStats from './_partials/AdoptableCardStats';
import AdoptableDetailsRightSide from './_partials/AdoptableDetailsRightSide';

interface Props
  extends Pick<
    DeviationShopCardProps,
    'detailsRightSlot' | 'footerSlot' | 'allowedIndicators'
  > {
  deviation: PapiDeviation;
  width: number;
  withAuthorDetails?: boolean;
  overrideHref?: string;
  withOwnerDetails?: boolean;
  hidePrice?: boolean;
  hideSold?: boolean;
}

const AdoptableShopCard: React.FC<Props> = ({
  width,
  deviation,
  withAuthorDetails,
  withOwnerDetails,
  allowedIndicators,
  overrideHref,
  hidePrice,
  hideSold,
  ...deviationShopCardProps
}) => {
  return (
    <DeviationShopCard
      width={width}
      deviation={deviation}
      overrideHref={overrideHref}
      noCentsOnPrice
      withStats
      withDescriptionBlock={false}
      withAuthorDetails={withAuthorDetails}
      allowedIndicators={allowedIndicators}
      belowCoverImageRightSlot={<AdoptableCardStats deviation={deviation} />}
      detailsRightSlot={
        <AdoptableDetailsRightSide
          deviation={deviation}
          hideSold={hideSold}
          hidePrice={hidePrice}
        />
      }
      withOwnerDetails={withOwnerDetails}
      {...deviationShopCardProps}
    />
  );
};
AdoptableShopCard.displayName = 'AdoptableShopCard';

export default AdoptableShopCard;
